fragment ContextDocumentFragment on ContextDocument {
    id
    name
    url {
        id
        fullyQualifiedUrl
        pageTitle
    }
    content
    summary
    isIncluded
    effectiveStatus
    wordCount
    isSubpage
    sourceType
    lastCrawledTime
    aiSuggestions {
        id
        content
    }
}
